import { DEFAULT_FONT_FAMILY, GenericFont } from 'common';

/** Font class. */
export class Font {
  constructor(
    /** Font name. */
    public name: GenericFont = DEFAULT_FONT_FAMILY,
    /** Bold state. */
    public bold: boolean = false,
    /** Italic state. */
    public italic: boolean = false,
    /** Font size */
    public size: number = 70,
    /** Strikeout state. */
    public strikeout: boolean = false,
    /** Underline state. */
    public underline: boolean = false
  ) {}
}

/** Create Font using partial config object, defaults to Helvetica with size 70. */
export const createFont = (config: Partial<Font> = {}) =>
  new Font(
    config.name,
    config.bold,
    config.italic,
    config.size,
    config.strikeout,
    config.underline
  );
